// to show product photo carousal after title,price,reviews in mobile screens


// (() => {
//   const mq = window.matchMedia("(max-width: 767px)");

//   let originalParent = null;
//   let originalNextSibling = null;

//   function run() {
//     const gallery = document.querySelector(".product-media");
//     const reviews = document.querySelector(
//       "#shopify-block-ATFROcGxoZW9HVG9qM__judge_me_reviews_preview_badge_HpKgmH"
//     );

//     if (!gallery || !reviews) return;

//     // Store original position ONCE
//     if (!originalParent) {
//       originalParent = gallery.parentElement;
//       originalNextSibling = gallery.nextElementSibling;
//     }

//     if (mq.matches) {
//       //  Mobile → move below reviews
//       reviews.after(gallery);
//     } else {
//       // Desktop → restore original position
//       if (originalNextSibling) {
//         originalParent.insertBefore(gallery, originalNextSibling);
//       } else {
//         originalParent.appendChild(gallery);
//       }
//     }

//     // Unlock visibility after correct placement
//     document.body.classList.add("js-media-ready");
//   }

//   // Run ASAP
//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", run);
//   } else {
//     run();
//   }

//   // Listen to screen size changes
//   mq.addEventListener("change", run);
// })();















(() => {
  const mq = window.matchMedia("(max-width: 767px)");

  let originalParent = null;
  let originalNextSibling = null;

  function run() {
    const gallery = document.querySelector(".product-media");

    const title =
  document.querySelector(".product-title") ||
  document.querySelector(".product__title") ||
  document.querySelector("h1");

if (!gallery || !title) return;

    // Store original position ONCE
    if (!originalParent) {
      originalParent = gallery.parentElement;
      originalNextSibling = gallery.nextElementSibling;
    }

    if (mq.matches) {
  // Mobile → move gallery above product title
  title.before(gallery);
} else {
      // Desktop → restore original position
      if (originalNextSibling) {
        originalParent.insertBefore(gallery, originalNextSibling);
      } else {
        originalParent.appendChild(gallery);
      }
    }

    // Unlock visibility after correct placement
    document.body.classList.add("js-media-ready");
  }

  // Run ASAP
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Listen to screen size changes
  mq.addEventListener("change", run);
})();
